import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=32379ff7&scoped=true"
import script from "./ModifyPassword.vue?vue&type=script&lang=js"
export * from "./ModifyPassword.vue?vue&type=script&lang=js"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=32379ff7&prod&lang=scss&scoped=true"
import style1 from "./ModifyPassword.vue?vue&type=style&index=1&id=32379ff7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32379ff7",
  null
  
)

export default component.exports